import { render, staticRenderFns } from "./ProjectPickerPromt.vue?vue&type=template&id=09156de6&scoped=true&"
import script from "./ProjectPickerPromt.vue?vue&type=script&lang=js&"
export * from "./ProjectPickerPromt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09156de6",
  null
  
)

export default component.exports